var map = {
  "./cs.json": [
    "LN",
    [
      "9k"
    ]
  ],
  "./en.json": [
    "NWK",
    [
      "zx"
    ]
  ],
  "./pl.json": [
    "I0h",
    [
      "mt"
    ]
  ],
  "./ru.json": [
    "mOc",
    [
      "gb"
    ]
  ],
  "./tr.json": [
    "Gup",
    [
      "cz"
    ]
  ],
  "./ja.json": [
    "m9t",
    [
      "g2s"
    ]
  ],
  "./zh.json": [
    "pjQ",
    [
      "vd"
    ]
  ],
  "./pt-br.json": [
    "FL",
    [
      "3e"
    ]
  ],
  "./de.json": [
    "mw",
    [
      "gp"
    ]
  ],
  "./es.json": [
    "Rsa",
    [
      "vlu"
    ]
  ],
  "./fr.json": [
    "iXT",
    [
      "kc"
    ]
  ],
  "./it.json": [
    "nRG",
    [
      "huh"
    ]
  ],
  "./ko.json": [
    "VmJ",
    [
      "bn"
    ]
  ],
  "./pt.json": [
    "Cs",
    [
      "sw"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "uL";
module.exports = __rspack_async_context;
